class GustoStickyATC {
  constructor(bar) {
    this.bar = bar;
    if (!this.bar) return;

    this.sectionId = this.bar.dataset.sectionId;
    this.mainButton = document.querySelector(`#ProductSubmitButton-${this.sectionId}`);
    this.atcButton = this.bar.querySelector('[data-sticky-atc-trigger]');
    this.price = this.bar.querySelector('.gusto-sticky-atc__price');
    this.productForm = this.mainButton?.closest('form');

    if (!this.mainButton || !this.atcButton || !this.productForm) return;

    this.atcButton.addEventListener('click', () => {
      this.mainButton.click();
    });

    this.syncPurchaseState();

    this.buttonObserver = new MutationObserver(() => this.syncPurchaseState());
    this.buttonObserver.observe(this.mainButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
      childList: true,
      subtree: true,
    });

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.bar.hidden = entry.isIntersecting;
          });
        },
        { threshold: 0.01 }
      );
      this.observer.observe(this.mainButton);
    } else {
      this.handleViewportChange = () => {
        window.requestAnimationFrame(() => {
          const bounds = this.mainButton.getBoundingClientRect();
          const isVisible = bounds.bottom > 0 && bounds.top < window.innerHeight;
          this.bar.hidden = isVisible;
        });
      };

      window.addEventListener('scroll', this.handleViewportChange, { passive: true });
      window.addEventListener('resize', this.handleViewportChange);
      this.handleViewportChange();
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
        window.requestAnimationFrame(() => this.syncPurchaseState());
      });
    }
  }

  syncPurchaseState() {
    const buttonLabel = this.mainButton.querySelector('span');
    const stickyLabel = this.atcButton.querySelector('span');
    const sourcePrice = document.querySelector(`#price-${this.sectionId}`);

    this.atcButton.disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';

    if (buttonLabel && stickyLabel) {
      stickyLabel.textContent = buttonLabel.textContent.trim();
    } else if (buttonLabel) {
      this.atcButton.textContent = buttonLabel.textContent.trim();
    }

    if (sourcePrice && this.price) {
      this.price.innerHTML = sourcePrice.innerHTML;
    }
  }
}

const initializeGustoStickyATC = (scope = document) => {
  scope.querySelectorAll('.gusto-sticky-atc').forEach((bar) => {
    if (bar.dataset.stickyAtcReady === 'true') return;
    bar.dataset.stickyAtcReady = 'true';
    new GustoStickyATC(bar);
  });
};

document.addEventListener('DOMContentLoaded', () => initializeGustoStickyATC());
document.addEventListener('shopify:section:load', (event) => initializeGustoStickyATC(event.target));
